// A same-site path to send someone back to after login, or null. Requiring a
// leading "/" alone isn't enough: "//evil.com" and "/\evil.com" are both
// read by the browser as a different host, which made ?returnTo= an open
// redirect straight after a real login.
export default function safeReturnTo(raw) {
  return typeof raw === 'string' && /^\/(?![/\\])/.test(raw) ? raw : null;
}

// A brand-new account always goes through onboarding (username, goal,
// profile) before anything else, which used to throw away where the visitor
// was headed: "Apply" on a job ended in generic onboarding with the job lost.
// Signup parks the destination here; the last onboarding step takes it.
// sessionStorage, so it dies with the tab and can't resurface days later.
const KEY = 'uf.pendingReturnTo';

export function rememberReturnTo(raw) {
  const safe = safeReturnTo(raw);
  try {
    if (safe) sessionStorage.setItem(KEY, safe);
    else sessionStorage.removeItem(KEY);
  } catch { /* storage blocked: onboarding just ends at its default */ }
}

export function peekReturnTo() {
  try { return safeReturnTo(sessionStorage.getItem(KEY)); } catch { return null; }
}

export function takeReturnTo() {
  const value = peekReturnTo();
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  return value;
}
